module.exports = __webpack_public_path__ + "img/Terrell-t-26708-020.cfcae442.jpg";